module.exports = __webpack_public_path__ + "img/7.aaeac215.png";